/* Bange product page — keep add-to-cart availability in sync with the selected variant.
   This is a small safety layer around the theme's native variant logic. */
(function () {
  'use strict';

  function getVariants(details) {
    var json = details.querySelector('[data-bange-product-variants-json]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getSelectedOptions(details) {
    var options = [];
    details.querySelectorAll('.product-options .product-option').forEach(function (option) {
      var checked = option.querySelector('input[type="radio"]:checked');
      var select = option.querySelector('select');
      if (checked) options.push(checked.value);
      else if (select) options.push(select.value);
    });
    return options;
  }

  function getSelectedVariant(details) {
    var variants = getVariants(details);
    if (!variants.length) return null;

    var options = getSelectedOptions(details);
    if (!options.length) {
      var idInput = details.querySelector('form [name="id"]');
      var id = idInput ? Number(idInput.value) : Number(details.dataset.id);
      return variants.find(function (variant) { return Number(variant.id) === id; }) || null;
    }

    return variants.find(function (variant) {
      if (!Array.isArray(variant.options) || variant.options.length !== options.length) return false;
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    }) || null;
  }

  function syncVariantState(details) {
    if (!details || !details.classList.contains('product-single')) return;

    var variant = getSelectedVariant(details);
    if (!variant) return;

    var variantId = String(variant.id);
    var available = variant.available === true;
    var idInput = details.querySelector('form [name="id"]');
    var variantMeta = details.querySelector('.product-variant input[name="variants[]"][value="' + variantId + '"]');

    details.dataset.id = variantId;
    details.dataset.available = available ? 'true' : 'false';

    if (idInput) {
      idInput.value = variantId;
      idInput.dataset.available = available ? 'true' : 'false';
      if (variantMeta) {
        idInput.dataset.policy = variantMeta.dataset.policy || '';
        idInput.dataset.qty = variantMeta.dataset.qty || '';
        details.dataset.policy = variantMeta.dataset.policy || '';
        details.dataset.max = variantMeta.dataset.qty || '';
      }
    }

    var button = details.querySelector('.add-to-cart-button');
    if (!button) return;

    var settings = window.theme && window.theme.settings ? window.theme.settings : {};
    var buttons = button.closest('.product-buttons');
    var isPreorder = buttons && buttons.classList.contains('product-preorder');
    var isRestock = buttons && buttons.classList.contains('restock-alert');

    button.disabled = !available;
    button.classList.toggle('expired-to-cart', !available);

    if (available) {
      button.innerHTML = isPreorder ? (settings.preOrder || 'Précommander') : (settings.addToCartText || 'Ajouter au panier');
    } else {
      button.innerHTML = isRestock ? (settings.notifyMe || settings.soldOutText || 'Stock épuisé') : (settings.soldOutText || 'Stock épuisé');
    }

    var dynamicCheckout = details.querySelector('#dynamic-checkout-button');
    if (dynamicCheckout) dynamicCheckout.classList.toggle('hide', !available);

    var quantity = details.querySelector('[name="quantity"]');
    if (quantity) {
      if (!available) {
        quantity.max = 0;
        quantity.value = 0;
      } else {
        if (Number(quantity.value) < 1) quantity.value = 1;
        if (variantMeta && variantMeta.dataset.policy === 'deny' && Number(variantMeta.dataset.qty) > 0) {
          quantity.max = variantMeta.dataset.qty;
          quantity.dataset.policy = 'deny';
        } else {
          quantity.removeAttribute('max');
          quantity.dataset.policy = variantMeta ? (variantMeta.dataset.policy || 'continue') : 'continue';
        }
      }
    }
  }

  function scheduleSync(details) {
    window.setTimeout(function () { syncVariantState(details); }, 0);
  }

  document.addEventListener('change', function (event) {
    var control = event.target.closest('.product-details.product-single .product-options input, .product-details.product-single .product-options select');
    if (!control) return;
    scheduleSync(control.closest('.product-details.product-single'));
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-details.product-single').forEach(function (details) {
      syncVariantState(details);
    });
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.product-details.product-single').forEach(function (details) {
      syncVariantState(details);
    });
  });
})();
